import React from 'react';
import { StyledCodeSkeleton } from './code.style';

const CodeSkeleton = () => <StyledCodeSkeleton />;

export default CodeSkeleton;
